export namespace AccessKeyConstants {
  export enum ACCESS_KEY_LABEL {
    ACCESS_KEY_LABEL_CHANGE_EMAIL = 'ACCESS_KEY_LABEL_CHANGE_EMAIL',
    ACCESS_KEY_LABEL_CHANGE_MOBILE_NUMBER = 'ACCESS_KEY_LABEL_CHANGE_MOBILE_NUMBER',
    ACCESS_KEY_LABEL_ADD_EMAIL = 'ACCESS_KEY_LABEL_ADD_EMAIL',
    ACCESS_KEY_LABEL_ADD_MOBILE_NUMBER = 'ACCESS_KEY_LABEL_ADD_MOBILE_NUMBER',
  }

  export enum ACCESS_KEY_TYPE {
    ACCESS_KEY_TYPE_CHANGE_EMAIL = 'ACCESS_KEY_TYPE_CHANGE_EMAIL',
    ACCESS_KEY_TYPE_CHANGE_MOBILE_NUMBER = 'ACCESS_KEY_TYPE_CHANGE_MOBILE_NUMBER',
    ACCESS_KEY_TYPE_ADD_EMAIL = 'ACCESS_KEY_TYPE_ADD_EMAIL',
    ACCESS_KEY_TYPE_ADD_MOBILE_NUMBER = 'ACCESS_KEY_TYPE_ADD_MOBILE_NUMBER',
  }
}
